import { Header } from './Header';
import { RotateDeviceTag } from './RotateDeviceTag';
import { PlayerExperience } from './PlayerExperience';
import { useScreenOrientation } from '../../hooks/useScreenOrientation';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { Loading } from '../../components/Loading';
import clsx from 'clsx';

export const CitrusViewContent = () => {
  const { hasCitrusView, loading, rebooting, isMobile } = useCitrusView();
  const isPortrait = useScreenOrientation('portrait');

  if (loading && !rebooting) return <Loading />;

  if (!hasCitrusView)
    return <h2 className="text-2xl">CITRUS View is not configured</h2>;

  return (
    <>
      <Header text="CITRUS View" />
      <RotateDeviceTag isPortrait={isPortrait} />
      <PlayerExperience isPortrait={isPortrait} />
      <div
        id="cv-portal-out"
        className={clsx({
          'fixed inset-0 w-screen h-screen z-[9995]': isMobile,
        })}
      />
    </>
  );
};
